<div class="blockCardContainer">
    <div class="imageContainer">
        <img [defaultImage]="defaultImage" [lazyLoad]="image">
    </div>
    <div class="contentContainer">
        <h1>{{ title }}</h1>
    </div>
</div>